import React from 'react';
import { usePopupManager, useShowContextRequired } from 'ui-builder';
import { ConfirmDeletePopup, IconButton, IconType } from 'features/nekst-widgets';
import { ProjectDocument, useProjectDocumentsService } from 'nekst-api';

function DeleteDocumentForm(
  props: {
    data: ProjectDocument,
  },
) {
  const projectDocumentsService = useProjectDocumentsService();

  const name = props.data._file?.name || props.data._label?.name;

  return (
    <ConfirmDeletePopup
      deleteFunc={() => projectDocumentsService.deleteProjectDocument(props.data.id)}
      message={`Are you sure you want to delete "${name}" document?`}
    />
  );
}

export default function DeleteDocumentButton() {
  const popupManager = usePopupManager();
  const showContext = useShowContextRequired<ProjectDocument>();

  return (
    <IconButton
      type={IconType.TRASH_CAN}
      onClick={() => popupManager.openPopup(<DeleteDocumentForm data={showContext.data} />)}
      title="Delete Document"
    />
  );
}
